import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useCallback } from 'react';
import { useKeyboardShortcut } from '../../../hooks/useKeyboardShortcut';

interface ConfirmationProps {
  title?: string;
  message: string;
  onDecline?(): void;
  onAccept?(): void;
  children?: any;
}

const Confirmation = ({
  children, title = 'Please confirm', message, onDecline, onAccept,
}: ConfirmationProps): React.ReactElement => {
  // `Enter` confirms the dialog (Yes / Accept). `Esc` is already handled by
  // Kendo Dialog itself — it fires `onClose`, which we point at `onDecline`.
  const acceptHandler = useCallback(() => {
    onAccept?.();
  }, [onAccept]);

  useKeyboardShortcut({
    key: 'Enter',
    handler: acceptHandler,
    enabled: Boolean(onAccept),
  });

  return (
    <Dialog title={title} onClose={onDecline}>
      <p>{message}</p>
      <DialogActionsBar>
        {children || (
          <>
            <button type="button" className="k-button-md" onClick={onDecline}>No</button>
            <button type="button" className="k-button-md" onClick={onAccept}>Yes</button>
          </>
        )}
      </DialogActionsBar>
    </Dialog>
  );
};

export default Confirmation;
